import React from 'react';
import { useQuery } from '@tanstack/react-query';
import SortableSelect from '../LocationsField/SortableSelect/SortableSelect.jsx';
import { Loader } from '@components/Loader/Loader.jsx';

import { postsQuery } from '@queries';

const BlogsSelectField = ({ field, allBlogsData }) => {
  const allBlogsOptions = allBlogsData.map((blog) => {
    return {
      value: blog.id,
      label: blog.title,
    };
  });

  // the stored value can reference blog posts that no longer exist, so only
  // pass along the ids we have an option for
  const existingBlogIDs = new Set(
    allBlogsOptions.map((option) => option.value),
  );
  const fieldValue = (field.value || []).filter((blogID) =>
    existingBlogIDs.has(blogID),
  );

  return (
    <SortableSelect
      name={field.name}
      inputRef={field.ref}
      options={allBlogsOptions}
      isClearable={true}
      className="basic-multi-select"
      classNamePrefix="select"
      onChange={(val) => {
        field.onChange((val || []).map((v) => v.value));
      }}
      fieldValue={fieldValue}
    />
  );
};

const BlogsSelect = ({ field, siteID, defaultBlogs = [] }) => {
  const { data: allBlogsData, isPending: allBlogsPending } = useQuery(
    postsQuery({
      limit: 5000,
      order_by: '-date',
      site_id: siteID,
      _fields: ['id', 'title'].join(','),
    }),
  );

  return (
    <>
      {allBlogsData && (defaultBlogs.length === 0 || !allBlogsPending) ? (
        <BlogsSelectField field={field} allBlogsData={allBlogsData.objects} />
      ) : (
        <Loader />
      )}
    </>
  );
};

export default BlogsSelect;
